import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsCollectorsAddRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-collectors-add',
	path: '/secure/AddCollector([!%]?[\\w]*).jspa',
	query: ['projectKey'],
};
